import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { CartProvider } from './context/CartContext';
import { Layout } from './components/layout/Layout';
// Pages
import { HomePage } from './pages/HomePage';
import { ProductListingPage } from './pages/ProductListingPage';
import { ProductDetailPage } from './pages/ProductDetailPage';
import { CartPage } from './pages/CartPage';
import { CheckoutPage } from './pages/CheckoutPage';
import { OrderConfirmationPage } from './pages/OrderConfirmationPage';
import { PaymentPage } from './pages/PaymentPage';
import { LoginPage } from './pages/LoginPage';
import { RegisterPage } from './pages/RegisterPage';
import { AccountPage } from './pages/AccountPage';
import { ContactPage } from './pages/ContactPage';
import { AboutPage } from './pages/AboutPage';
import { FAQPage } from './pages/FAQPage';
import { AdminDashboard } from './pages/admin/AdminDashboard';
export function App() {
  return <Router data-id="element-0" data-mp="3ijfw82xf22g7">
      <AuthProvider data-id="element-1" data-mp="3ijpet5g4t7bv">
        <CartProvider data-id="element-2" data-mp="3mlj9mx3nbh44">
          <Routes data-id="element-3" data-mp="3ml12h5fg3ihf">
            {/* Admin Routes (No Main Layout) */}
            <Route path="/admin" element={<AdminDashboard data-id="element-5" data-mp="3rbrc4uuwm7hx" />} data-id="element-4" data-mp="3mj6jhwnqi0fz" />
            <Route path="/admin/*" element={<AdminDashboard data-id="element-7" data-mp="3relvej26lm9r" />} data-id="element-6" data-mp="3rcsyhvhdegey" />

            {/* Auth Routes (No Main Layout) */}
            <Route path="/login" element={<LoginPage data-id="element-9" data-mp="2zl3dbpgpde7f" />} data-id="element-8" data-mp="56qxrrj5tst" />
            <Route path="/register" element={<RegisterPage data-id="element-11" data-mp="2zmwj72jhrued" />} data-id="element-10" data-mp="2zlv32jnmchps" />

            {/* Paysys Labs Payment Gateway (No Main Layout) */}
            <Route path="/payment" element={<PaymentPage data-id="element-13" data-mp="38lro8basuyg3" />} data-id="element-12" data-mp="33mymfg4vkvvr" />

            {/* Main App Routes (With Layout) */}
            <Route path="*" element={<Layout data-id="element-15" data-mp="3dkl42adk71jf">
                  <Routes data-id="element-16" data-mp="3dl4jnkfqldua">
                    <Route path="/" element={<HomePage data-id="element-18" data-mp="3dii4aymltu1i" />} data-id="element-17" data-mp="3dmfozootytni" />
                    <Route path="/products" element={<ProductListingPage data-id="element-20" data-mp="nv0ybtt2yq5o" />} data-id="element-19" data-mp="nw2egcoye2u9" />
                    <Route path="/product/:slug" element={<ProductDetailPage data-id="element-22" data-mp="stkok6epio3u" />} data-id="element-21" data-mp="sunf2d84aoj8" />
                    <Route path="/cart" element={<CartPage data-id="element-24" data-mp="35ypel6klo1z" />} data-id="element-23" data-mp="swgkjp6zv2pn" />
                    <Route path="/checkout" element={<CheckoutPage data-id="element-26" data-mp="38b4mqky1kbc" />} data-id="element-25" data-mp="356wxj89s6fx" />
                    <Route path="/order-confirmation" element={<OrderConfirmationPage data-id="element-28" data-mp="3ucjehzd2elwd" />} data-id="element-27" data-mp="3udkoe0ich2ci" />
                    <Route path="/account/*" element={<AccountPage data-id="element-30" data-mp="d45sc040y5kz" />} data-id="element-29" data-mp="d57fv4288kjl" />
                    <Route path="/contact" element={<ContactPage data-id="element-32" data-mp="85bb32lpgp2z" />} data-id="element-31" data-mp="85l3ewu838bu" />
                    <Route path="/about" element={<AboutPage data-id="element-34" data-mp="3gle8mfj3sxdl" />} data-id="element-33" data-mp="86cmx9ajpflr" />
                    <Route path="/faq" element={<FAQPage data-id="element-36" data-mp="3glwg68b7uy0t" />} data-id="element-35" data-mp="3gmfw5jhb3cc7" />
                    <Route path="/wishlist" element={<Navigate to="/account" replace data-id="element-38" data-mp="3bn2zy84joswy" />} data-id="element-37" data-mp="3bmbf9schkflg" />
                    <Route path="*" element={<Navigate to="/" replace data-id="element-40" data-mp="3qbpnuy88mszs" />} data-id="element-39" data-mp="3bkgs07dqsbe7" />
                  </Routes>
                </Layout>} data-id="element-14" data-mp="38nupjrheke04" />
          </Routes>
        </CartProvider>
      </AuthProvider>
    </Router>;
}